import PageNotFound from '../../../assets/images/500 & 503.svg'

type ErrorProps = {
    error: Error ;
    resetErrorBoundary: () => void;
  };


const FallbackRender =  ({ error, resetErrorBoundary }:ErrorProps) => {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.
    return (
      <div role="alert">
        {/* <p>Something went wrong:</p>
        <pre style={{color: 'red'}}>{error.message}</pre> */}
        <div className='unauthorized-container fallback'>
            <p className="error-name">Something went wrong !</p>
            <div className="center-block">           
                <img src={PageNotFound} alt="Error Image" className="error-image" />     
            </div>
            <p className="error-description">{error.message}</p>
        </div>
      </div>
    );
  }

export default FallbackRender;
